/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  EpkModuleApiService,
  getFilteredData,
} from '~packages/epk-front-shared/api-client';
import type { Filters, Params } from '~packages/epk-front-shared/api-client';
import { Mode, RequestMethod } from '~packages/json-api/client';

import getConstants from '@/shared/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'RegHeadLphApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  needInit: isModeDevelopment,
};

export default class RegHeadLphApiService extends EpkModuleApiService {
  constructor() {
    super(constructorParams);
  }
  async getAllCards(params?: any) {
    return await super.fetchAll(params);
  }
  async getAllCardsVer2(filters: Filters, params: Params) {
    return await getFilteredData(this, filters, params, {}, {}, '/v2');
  }
  async getCardItem(id: string | number) {
    return await super.fetch(id);
  }
  async getFilteredData(filters: Filters, params: Params) {
    return await getFilteredData(this, filters, params);
  }
  async postAllCards(obj: Record<string, any>) {
    return await super.add(obj);
  }
  async transfer(data: Record<string, any>, params: any) {
    return await this._sendRequest(
      this.pathAdd,
      params,
      { body: this.jsonStringify(data), method: RequestMethod.POST },
      { method: 'transfer' }
    );
  }
  async updateAccounts(pointCode: number, body: Record<string, any>) {
    return await this._sendRequest(
      this.pathUpdate + `${pointCode}/change-accounts`,
      null,
      { method: this.requestMethodUpdate, body: JSON.stringify(body) },
      { method: 'update' }
    );
  }
  async updatePassport(pointCode: number, body: Record<string, any>) {
    return await this._sendRequest(
      this.pathUpdate + `${pointCode}/new-passport`,
      null,
      { method: this.requestMethodUpdate, body: JSON.stringify(body) },
      { method: 'update' }
    );
  }
  async updateCard(
    pointCode: number | string | string[],
    body: Record<string, any>
  ) {
    return await this._sendRequest(
      this.pathUpdate + `${pointCode}`,
      null,
      { method: this.requestMethodUpdate, body: JSON.stringify(body) },
      { method: 'updateCard' }
    );
  }
  async postAllCardsEdit(body: any) {
    return await this._sendRequest(
      this.pathAdd + `?old_head_lph= ${body.id}`,
      null,
      { method: this.requestMethodAdd, body: JSON.stringify(body) },
      { method: 'add' }
    );
  }
  async refreshCard(pointCode: number) {
    return await this._sendRequest(
      this.pathAdd + `${pointCode}/refresh`,
      null,
      { method: this.requestMethodUpdate },
      { method: 'refreshCard' }
    );
  }
  async deleteByCode(code: string) {
    return await this._sendRequest(
      `/${code}`,
      undefined,
      { method: RequestMethod.DELETE },
      { method: 'delete' }
    );
  }
  async getRelated(code: string) {
    return await this._sendRequest(
      `/${code}/related`,
      undefined,
      { method: RequestMethod.GET },
      { method: 'related' }
    );
  }
}
